import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import {
  RepaymentAmountResponse,
  SmartPayAsYouGoEligibilityResponse,
  SmartPayAsYouGoExecutionDateResponse,
} from "@/api/backofficeRest/generated/model"

export interface ISmartPayAsYouGoService {
  checkSpaygEligibility(
    accountNumber: string,
  ): QueryResult<SmartPayAsYouGoEligibilityResponse[]>
  getExecutionDate(accountNumber: string): QueryResult<string | undefined>
}

class SmartPayAsYouGoClass implements ISmartPayAsYouGoService {
  checkSpaygEligibility(accountNumber: string) {
    return useQuery({
      ...BackofficeRestQueries.smartPayAsYouGo.checkEligibility(accountNumber),
      placeholderData: [] as SmartPayAsYouGoEligibilityResponse[],
      useRawResponse: true,
      parserFn: (data: SmartPayAsYouGoEligibilityResponse[]) => data ?? [],
    })
  }

  getExecutionDate(accountNumber: string) {
    return useQuery<SmartPayAsYouGoExecutionDateResponse, string | undefined>({
      ...BackofficeRestQueries.smartPayAsYouGo.getExecutionDate(accountNumber),
      placeholderData: undefined,
      useRawResponse: true,
      parserFn: (data) => data?.executionDate,
    })
  }

  getRepaymentAmountDefaultValues() {
    return useQuery({
      ...BackofficeRestQueries.smartPayAsYouGo.getRepaymentAmount,
      useRawResponse: true,
      parserFn: (data: RepaymentAmountResponse) =>
        data ?? ({} as RepaymentAmountResponse),
    })
  }
}

export const SmartPayAsYouGoService = new SmartPayAsYouGoClass()
